import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const typographyVariants = cva('font-raleway', {
  variants: {
    variant: {
      h1: 'text-4xl font-bold text-brand-black',
      h2: 'text-3xl font-semibold text-brand-black',
      h3: 'xl:text-2xl lg:text-xl md:text-lg font-semibold text-brand-black',
      h4: 'text-xl font-medium text-brand-black',
      h5: 'text-lg font-medium text-brand-black',
      h6: 'lg:text-base md:text-sm font-medium text-brand-black',
      label: 'lg:text-sm md:text-xs font-medium text-brand-black',
      body: 'text-base text-brand-black-2',
      bodySmall: 'text-sm text-brand-black-2',
      caption: 'lg:text-xs md:text-[10px] text-brand-black-2',
      link: 'text-xs text-brand-dark-orange cursor-pointer hover:underline',
      error: 'text-xs text-brand-error-red',
    },
    weight: {
      light: 'font-light',
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extrabold: 'font-extrabold',
    },
  },
  defaultVariants: {
    variant: 'body',
    weight: 'normal',
  },
});
type TypographyProps<T extends React.ElementType> = {
  as?: T;
  className?: string;
} & VariantProps<typeof typographyVariants> &
  Omit<React.ComponentPropsWithoutRef<T>, 'as' | 'className'>;

export function Typography<T extends React.ElementType = 'div'>({
  as,
  className,
  variant,
  weight,
  ...props
}: TypographyProps<T>) {
  const Component = as || 'div';
  return (
    <Component
      className={cn(typographyVariants({ variant, weight }), className)}
      {...props}
    />
  );
}
